// Centralized RTSP Stream Configuration for IoT Admin Dashboard
// Dynamically supports any stream prefix configured by admin (Cam, Smartlight, Pole, etc.)
// Across Video + Audio, Thermal, and Audio streams

export const cleanPrefixName = (prefix) => {
  if (!prefix) return 'Cam';
  const cleaned = String(prefix).trim().replace(/[^a-zA-Z0-9_-]/g, '');
  return cleaned || 'Cam';
};

export const getBaseStreamUrls = () => {
  return {
    VIDEO: process.env.REACT_APP_VIDEO_STREAM_URL || 'rtsp://reader:Smartlight123@164.52.201.205:8554/Cam-001/video',
    AUDIO: process.env.REACT_APP_AUDIO_STREAM_URL || 'rtsp://reader:Smartlight123@164.52.201.205:8554/Cam-001/audio',
    THERMAL: process.env.REACT_APP_THERMAL_STREAM_URL || 'rtsp://reader:Smartlight123@164.52.201.205:8554/Cam-001/thermal',
    PUBLISH_AUDIO: process.env.REACT_APP_PUBLISH_AUDIO_STREAM_URL || 'rtsp://publisher:Smartlight123@164.52.201.205:8554/Cam-001/app'
  };
};

export const RTSP_URLS = getBaseStreamUrls();

/**
 * Normalizes deviceId into standard 3-digit zero-padded string (e.g. 1 -> "001", "10" -> "010")
 */
export const formatDeviceId = (deviceId) => {
  if (!deviceId) return '001';
  const str = String(deviceId).trim();
  const digitsOnly = str.replace(/\D/g, '');
  if (!digitsOnly) return '001';
  return String(parseInt(digitsOnly, 10)).padStart(3, '0');
};

/**
 * Returns stream URL formatted with dynamic prefix and padded device ID.
 * Replaces any existing prefix pattern like Prefix-001 with [targetPrefix]-[formattedId].
 */
export const getDeviceStreamUrl = (streamType, deviceId, prefix = 'Cam') => {
  const cleanDevId = formatDeviceId(deviceId);
  const targetPrefix = cleanPrefixName(prefix);
  const typeKey = String(streamType || 'video').toUpperCase();
  const baseStreamUrl = RTSP_URLS[typeKey] || RTSP_URLS.VIDEO;
  return baseStreamUrl.replace(/[a-zA-Z0-9_-]+-\d+/gi, `${targetPrefix}-${cleanDevId}`);
};

/**
 * Returns publish audio stream URL for talkback microphone
 */
export const getDevicePublishAudioUrl = (deviceId, prefix = 'Cam') => {
  const cleanDevId = formatDeviceId(deviceId);
  const targetPrefix = cleanPrefixName(prefix);
  return RTSP_URLS.PUBLISH_AUDIO.replace(/[a-zA-Z0-9_-]+-\d+/gi, `${targetPrefix}-${cleanDevId}`);
};

export default RTSP_URLS;
